import type { ListingClickFact } from '@/analytics/models/siteCatalyst/ListingClickFact';
import {
  CHANNEL,
  EVENTS_TRACKING_VAR,
  LISTING_CLICK_EVENT,
  LOGGED_IN_ACCOUNT_USER_ID_PROP,
  PRODUCTS_TRACKING_VAR,
  SEARCH_SITE_SECTION,
  URL_OF_CURRENT_PAGE_EVAR,
  USER_LOGGED_IN_STATUS_AND_SITE_SECTION_PLUS_SUBSECTION_OR_VENUE_NAME_AND_CODE_EVAR,
  USER_LOGGED_IN_STATUS_AND_SITE_SECTION_PROP,
  VENUE_PROFILE_SITE_SECTION,
  SUPPLIER_NETWORK,
  NEW_OR_OLD_SEARCH_EVAR,
  NEW_CSN_SRP
} from '@/constants/SiteCatalystConstants';
import {
  getUserLoggedInStatusAndSiteSectionPlusVenueNameAndCodeString,
  getUserLoggedInStatusAndSiteSectionString,
  stringifyFact
} from './siteCatalystHelper';

export default function getAdClickFact(
  isLoggedIn: boolean,
  accountId: string | null,
  venueName: string,
  adCode: string,
  venueCode: string | undefined
): Record<string, string | null> {
  const fact: ListingClickFact = {
    [CHANNEL]: SUPPLIER_NETWORK,
    [LOGGED_IN_ACCOUNT_USER_ID_PROP]: accountId || null,
    [URL_OF_CURRENT_PAGE_EVAR]: typeof window === 'undefined' ? '' : window.location.href,
    [EVENTS_TRACKING_VAR]: LISTING_CLICK_EVENT.split(' '),
    [PRODUCTS_TRACKING_VAR]: adCode.split(' '),
    [USER_LOGGED_IN_STATUS_AND_SITE_SECTION_PROP]: getUserLoggedInStatusAndSiteSectionString(
      isLoggedIn,
      VENUE_PROFILE_SITE_SECTION
    ),
    [USER_LOGGED_IN_STATUS_AND_SITE_SECTION_PLUS_SUBSECTION_OR_VENUE_NAME_AND_CODE_EVAR]:
      getUserLoggedInStatusAndSiteSectionPlusVenueNameAndCodeString(
        isLoggedIn,
        venueName,
        venueCode,
        SEARCH_SITE_SECTION
      ),
    [NEW_OR_OLD_SEARCH_EVAR]: NEW_CSN_SRP
  };
  return stringifyFact(fact);
}
